<template>
  <div class="opt-in-terms-container">
    <ul class="terms">
      By signing below you agree to;
      <li>
        allow {{merchant.name}} to capture and retain your contact & purchase information 
        in order to provide you with a more personalized marketing and communications experience.
      </li>
      <li>
        <input
            class="allowed-sms-checkbox"
            type="checkbox" 
            v-model="optIn" 
            @change="$emit('setData', 'allowedSms', optIn)">
        by providing your mobile number and checking the box provided,
        you consent to receive marketing focused text messages and calls,
        including via an automatic telephone dialing system or prerecorded or artificial voice from {{merchant.name}}.
        And Its Affiliates, Brands, and Product Manufacturers. Consent is not required as a condition of purchasing any goods or services.
        Standard per minute call and message rates may apply.  Opt out at any time by replying ‘STOP’.
      </li>
      <li v-if="merchant.terms_and_conditions_link">
        agreeing to and accepting our terms and conditions which can be reviewed by clicking this link:
        <a
            class="terms-conditions-link"
            :href="merchant.terms_and_conditions_link">
          {{merchant.terms_and_conditions_link}}
        </a>
      </li>
      <li v-if="merchant.privacy_policy_url">
        for more information, click here:
        <a
            class="privacy-policy-link"
            :href="merchant.privacy_policy_url">
          {{merchant.privacy_policy_url}}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      merchant: Object,
      allowedSms: Boolean,
    },

    name: 'OptInTerms',

    data() {
      return {
        optIn: false,
      }
    },
    
    created() {
      this.optIn = this.allowedSms
    },
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.opt-in-terms-container
  .terms
    list-style: disc inside
    margin: 1rem auto
    padding: .25rem
    text-align: left

    li
      padding: .25rem 0
      line-height: 1.5

  input
    margin: 0 .5rem 0 0
    transform: scale(2)
</style>